<template>
    <div class="container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card>
            <v-card-title>
                Student Details
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="2">
                        <v-text-field dense v-model="rollno" label="Roll No." readonly filled outlined></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field dense v-model="grno" label="Registration No." readonly filled outlined></v-text-field>
                    </v-col>

                    <v-col cols="2">
                        <v-text-field dense v-model="studentname" label="Student Name" readonly filled outlined></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field dense v-model="standard" label="Standard" readonly filled outlined></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field dense v-model="division" label="Division" readonly filled outlined></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field dense v-model="ay" label="Academic Year" readonly filled outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row>
            <v-col>
                <v-card>
                    <!-- <v-card-title>
                        Attendance
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title> -->
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Learner Attendance</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          <v-btn class="mb-2 button" color="warning" :loading="add_load"  @click="getAttendanceDetes()">Add
            Attendance</v-btn>
        </v-toolbar>
                    <v-data-table :headers="headers" :items="studentinfo" :search="search" disable-pagination hide-default-footer>
                        <template v-slot:[`item.status`]="{ item }">
                            <v-avatar color="success" size="30" v-if="item.status == 'P'">
                                <span class="white--text headline">P</span>
                            </v-avatar>

                            <v-avatar v-else color="error" size="30">
                                <span class="white--text headline">A</span>
                            </v-avatar>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                            <!-- <v-switch @change="editItem(item)"></v-switch> -->
                            <v-row dense>
                                <v-switch v-model="item.is_present" @change="saveUpdateAttendance(item)"></v-switch>
                                <v-avatar size="35">
                                    <v-icon class="ml-4 pt-7 v-icon-size" color="red" @click="deleteAttendance(item)">mdi-trash-can</v-icon>
                                </v-avatar>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="add_attendance_card" max-width="900px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Mark Student Attendance</strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12">
            <v-card class="box">
              <v-row justify="center" dense>

                <v-col cols="12" sm="3" v-if="dates_list.length > 0">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="attendance_date" :items="dates_list"
                    item-text="date" label="Dates" item-value="date" outlined persistent-hint hint="Select Date"
                    multiple />
                </v-col>
                <v-col cols="12" sm="4" v-if="dates_list.length > 0">
                  <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Present" value="true" color="#0f2027"></v-radio>
                    <v-radio label="Absent" value="false" color="#0f2027"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row justify="center" dense>
                <v-btn class="button" @click="saveSingleAttendance()" 
                  v-if="this.attendance_date">save</v-btn>
                <v-btn class="button" @click="add_attendance_card = false">Close</v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-card>
      </v-dialog>
        <!--   {{editedItem}} -->
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            present: true,
            absent: false,
            headers: [
                { text: "SR No", value: "srno" },
                // { text: "Day Number", value: "dayno" },
                { text: "Date", value: "date" },
                { text: "Status", value: "status" },
                { text: "Action", value: "action", sortable: false },
            ],
            dates_list:[],
            singleSelect: false,
            selectedTasks: [],
            add_attendance_card:false,
            attendance_date:[],
            radios:null,
            add_load:false,
            divoff: "",
            studentinfo: "",
            ay: "",
            standard: "",
            division: "",
            dayno: "",
            search: "",
            date: "",
            snackbar_msg: null,
            snackbar: false,
            rollno: "",
            grno: "",
            studentname: "",
            editedItem: {
                la: "",
                dayno: "",
                date: "",
                status: "",
            },
        }),

        mounted() {
            this.getStudentAttendance();
        },
        methods: {
            getAttendanceDetes(){
            this.dates_list=[]
            const formData = {
                     //   learner_id: item.learner_id,
                        learner_division_id:this.$store.getters.ldiv_id
                    };
                    this.add_load = true
                axios
                .post("/Academics/getAttendanceDetes", formData)
                .then(res => {
                if (res.data.flag == "YES") {
                    this.dates_list = res.data.dates_list;
                    this.add_attendance_card = true
                    this.add_load = false
                } else {
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                    this.add_load = false
                }
                })
                .catch(error => {
                sessionStorage.setItem("error-trace", res.data.error_trace);
                window.console.log(error);
                this.add_load = false
                })
                .finally((
                ) => {
                    this.add_load = false
                });
            },
              saveSingleAttendance(){
       const formData = {
              //  learner: this.learner_attendance.learner_id,
                learner_division_id: this.$store.getters.ldiv_id,
                attendance_date:this.attendance_date,
                is_present:this.radios
             };
        this.add_load=true
         axios
        .post("/Academics/saveSingleAttendance", formData)
        .then(res => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully"); // show snackbar on success
           // this.attendance_list = res.data.learner_attendance_info;
            this.add_attendance_card=false,this.attendance_date=[]
            this.getStudentAttendance();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
          this.add_load=false
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.add_load=false
        })
        .finally(() => {
          this.delete_load=false
          this.add_attendance_card=false
          this.add_load=false
        });
    },
            deleteAttendance(item) {
                // alert('item'+item.divoff)
                if (!confirm("Are You Sure You Want To Delete This Date's Attendance...?")) return;
                const formData = {
                    attendance_id: item.la,
                };
                axios
                    .post("/Academics/deleteSingleAttendance", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Deleted Successfully"); // show snackbar on success
                            this.getStudentAttendance();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            saveUpdateAttendance(item) {
                const formData = {
                    learner_attendance_id: item.la,
                    is_present: item.is_present,
                };
                axios
                    .post("/Academics/saveUpdateAttendance", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.getStudentAttendance();
                            /// this.attendance_list = res.data.learner_attendance_info;
                            this.showSnackbar("#4caf50", "Updated Successfully...");
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStudentAttendance() {
                if (this.$store.getters.ldiv_id == null) {
                    // alert('divoff')
                    this.$router.push({ name: "mark-attendance" });
                }
                //this.divoff=this.$store.getters.divoff_id
                const data = {
                    ldiv: this.$store.getters.ldiv_id,
                    status: localStorage.getItem("setstatus_id"),
                };
                axios
                    .post("/Academics/getStudentAttendance", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.studentinfo = res.data.studentinfo;
                            this.ay = res.data.ay;
                            this.standard = res.data.standard;
                            this.division = res.data.division;
                            this.rollno = res.data.rollno;
                            this.grno = res.data.grno;
                            this.studentname = res.data.studentname;
                            //this.load=true
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            editItem(item) {
                //alert('stting')
                this.editedIndex = this.studentinfo.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.setStudentattendance();
                //this.$store.commit('setdivoff_id', this.editedItem.divoff)
                //this.dialog = true;
                //this.getDivisionStudents()
            },
            setStudentattendance() {
                const data = {
                    la: this.editedItem.la,
                };

                axios
                    .post("/Academics/editStudentAttendance", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.studentinfo = res.data.studentinfo;
                            this.snackbar_msg = res.data.snackbar_msg;
                            this.snackbar = true;
                            this.showSnackbar("#4caf50", this.snackbar_msg);
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
        },
    };
</script>
